module.exports = __webpack_public_path__ + "static/media/A_iko_2_kontrast__active.3af5d31a.svg";